<template>
  <section class="menu-banner">
    <base-image
      class="menu-banner__image"
      :mobile-url="fields.heroMobile?.value?.src"
      :tablet-url="fields.heroTablet?.value?.src"
      :desktop-url="fields.heroDesktop?.value?.src ?? ''"
      :desktop-alt="fields.heroDesktop?.value?.alt ?? ''"
      :tablet-alt="fields.heroTablet?.value?.alt"
      :mobile-alt="fields.heroMobile?.value?.alt"
      :full-width="true"
    />
    <div class="menu-banner__content-wrapper">
      <div class="container">
        <div class="menu-banner__content">
          <sc-text tag="h1" class="menu-banner__title font-l" :field="fields.headerBannerTitle" />
          <div
            v-if="jssStore.rawVenueId && jssStore.locationKey"
            class="menu-banner__reviews-section"
          >
            <button
              class="menu-banner__reviews-button link inverted-underline"
              @click="onVenueInfoClick"
            >
              <i class="icon icon-Info" aria-hidden="true" />
              {{ t('iorder-venue-food-hygiene-awards') }}
            </button>
          </div>
          <sc-text
            tag="p"
            class="menu-banner__description"
            :field="fields.headerBannerDescription"
          />
          <base-button
            v-if="fields.headerBannerCta?.value"
            :link="fields.headerBannerCta?.value"
            type="link"
            variant="secondary"
            class="menu-banner__cta"
            @click="registerDLAction(fields.headerBannerCta?.value?.text ?? '')"
          />
        </div>
      </div>
    </div>
  </section>
  <venue-info-modal
    ref="modalRef"
    :location-id="jssStore.locationKey"
    :venue-id="jssStore.rawVenueId"
    show-venue-info-first
  />
</template>

<script setup lang="ts">
import type { MenuBannerProps } from './types';
import { ref, defineAsyncComponent } from 'vue';
import { Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import { useI18n } from 'vue-i18n';
import BaseImage from '../../2_elements/BaseImage/BaseImage.vue';
import BaseButton from '../../2_elements/BaseButton/BaseButton.vue';
import { useButtonsAndLinksTracking } from '../../../data-layer/hooks/useButtonsAndLinksTracking';
import { useJssStore } from '../../../stores/jssStore';
const VenueInfoModal = defineAsyncComponent(
  () => import(/* webpackChunkName: "VenueInfoModal" */ '../../VenueInfoModal/VenueInfoModal.vue')
);

const jssStore = useJssStore();

const { t } = useI18n();

const { trackButtonState } = useButtonsAndLinksTracking({
  componentName: 'iorder_menu_header',
});

const props = withDefaults(defineProps<MenuBannerProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const modalRef = ref<InstanceType<typeof VenueInfoModal> | null>(null);

const onVenueInfoClick = () => {
  if (modalRef.value) {
    modalRef.value.openModal();
    registerDLAction(t('iorder-venue-food-hygiene-awards'));
  }
};

const registerDLAction = (linkText: string) => {
  trackButtonState(linkText);
};
</script>
<style lang="scss">
@import './scss/MenuBanner.scss';
</style>
